<template>
      <div no-body class="lku-salestdpcr"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else class="ml-3 mr-3">
        <b-col lg="10">
            <b-input-group >
                <b-input-group-prepend><label >Customer</label></b-input-group-prepend>
                <b-form-input v-model="tblData.customer" placeholder="Pemasang/Biro Iklan" :disabled="((customer_id||'') !== '')" @keyup.13.native="refresh()"></b-form-input>
                <b-form-input v-model="tblData.Advertiser" placeholder="Advertiser" @keyup.13.native="refresh()" class="ml-1"></b-form-input>
            </b-input-group>
              <b-row>
                <b-col md="5">
                  <b-input-group >
                      <b-input-group-prepend><label>CR Number </label></b-input-group-prepend>
                        <b-form-input v-model="tblData.nomor" @keyup.13.native="refresh()" placeholder="Order Number"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col md="7">
                  <b-input-group >
                      <b-input-group-prepend><span class="mt-2" >Description</span></b-input-group-prepend>                  
                        <b-form-input v-model="tblData.uraian" @keyup.13.native="refresh()" placeholder="Description"></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>       
        </b-col>
        <b-col lg="2">
                  <b-button variant="success" style="width:120px;" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                  <b-button class="btn btn-secondary" style="width:120px;" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
        </b-col>

      </b-row>
        <b-table
          class="mb-0"
          ref="tblsalestdpcr" style="font-size:smaller;" 
          responsive small striped hover
          :items="tblData.items"
          :fields="fields"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="updatetable" 
          @row-clicked="selectItem"
        >
        <template v-slot:cell(startdate)="data">
          {{ data.item.startdate | moment("DMMMYYYY") }} s.d {{ data.item.finishdate | moment("DMMMYYYY") }}
        </template>
          <template v-slot:cell(budget)="data">
              {{data.item.budget | numFormat}}
          </template>
        <template v-slot:cell(cashbackpc)="data">
          {{data.item.cashbackpc|numFormat}} &nbsp;%
        </template>

        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-salestdpcr {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import salestdpcr from "../../apis/salestdpcr";

export default {
  data() {
    return {
      lkuLoading:false,
      fields: [
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "CR Number",
            sortable: true
          },
          {
            key: "customer_name",
            label: "Customer Name",
            sortable: true
          },
          {
            key: "customer_Code",
            label: "Cust.Code",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "Advertiser",
            label: "Advertiser",
            sortable: true
          },
          {
            key: "startdate",
            label: "Billing Period",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "budget",
            thStyle: "width:100px",
            label: "Total Commitment",
            thClass: "text-center",
            tdClass: "text-right",
            variant: "primary" ,           
            sortable: true
          },
          {
            key: "cashbackpc",
            label: "Cash Back",
            thStyle: "width:40px",
            thClass: "text-center",
            tdClass: "text-right",
            variant: "primary" ,           
            sortable: true
          },
          {
            key: "paidtoname",
            label: "CashBack Paid To",
            sortable: true
          },
          {
            key: "issuccess",
            label: "Approval Status",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
      ],
      tblData: {
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'nomor',
        sortDesc: false,
        customer_id:''
      },
      updatetable:false
    };
  },
  computed: {
    filterCustomer() {
      return this.tblData.customer;
    },
    filtercustcode() {
      return this.tblData.customer_id;
    },
    pagechange() {
      return this.tblData.page;
    },
    limitchange() {
      return this.tblData.limit;
    },
  },
  watch: {
    filterCustomer: function(newval) {
      this.$emit('update:customer', newval);
    },    
    filtercustcode: function(newval) {
      this.$emit('update:customer_id', newval);
    },   
    pagechange: function(newval) {
      this.tblData.page=newval;
      this.refresh();
    },   
    limitchange: function(newval) {
      this.data();
    },   
  },
  props: ["customer", "customer_id"],
  created: async function() {
      this.tblData.customer=this.customer || '';
      this.tblData.customer_id=this.customer_id || '';
      // if (this.customer_id) {
        // if (this.formdata.items)
        // {
        //   if (this.formdata.items[0].customer_id!==this.customer_id) {
        //     this.data();
        //   } else {
        //     for (var key in this.formdata) {
        //         this.tblData[key] = this.formdata[key];
        //     }
        //   }
        // } else {
          // this.data();
        // }
      // } else {
      //   if (this.formdata.items)
      //   {
      //       for (var key in this.formdata) {
      //           this.tblData[key] = this.formdata[key];
      //       }
      //   } 
        // else {
        //   this.data();
        // }
      // }
      this.data();
 },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      const list = await salestdpcr.list(this.tblData);      
      this.lkuLoading=false;
      this.tblData.items=list;
      this.updatetable=!this.updatetable;
      // console.log('this.tblData : ',this.tblData);
    },
    selectItem(item,index) {
      // this.$emit("click", item);
      this.tblData.selected=item;
      this.$emit("click", item);
    },
    clearFilter() {
        this.Advertiser=  '';
        this.tblData.customer= '';
        this.tblData.customer_id=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
    },    
    keymonitor: function(event) {
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblsalestdpcr.refresh();
       }
    },    
    refresh() {
      this.data();
      this.$refs.tblsalestdpcr.refresh();
    }
  }
};
</script>
